import { render, staticRenderFns } from "./RenewAffiliateList.vue?vue&type=template&id=025ef7a4"
import script from "./RenewAffiliateList.vue?vue&type=script&lang=ts"
export * from "./RenewAffiliateList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports